// extracted by mini-css-extract-plugin
export default {"moreButton":"wantMoreButton-module__moreButton--tNSgp","colseButtonContainer":"wantMoreButton-module__colseButtonContainer--I_FFw"};